import React from 'react';
import PropTypes from 'prop-types';
import css from './MeetingInstructions.css';
import Title from 'common/Title';

export default class MeetingInstructions extends React.Component {

  render() {
    return (
      <div>
        <Title text="Meeting Instructions" />
        <div className={css['text']}>
          {this.props.instructions}
        </div>
      </div>
    );
  }
}

MeetingInstructions.propTypes = {
  instructions: PropTypes.string.isRequired,
};
